module.exports = __webpack_public_path__ + "static/media/uk-UA.404b1251.md";